import { cartStore } from '@/store/cartStore'
import dateService from '@/services/dateService'

export default {
    setItemsCart(items) {
        const store = cartStore()
        store.setItems(items)
    },
    setTimestampCart() {
        const store = cartStore()
        store.setTimestamp()
    },
    getItemsCart() {
        const store = cartStore()
        return store.items
    },
    getTotalCart() {
        const store = cartStore()
        return store.getTotal
    },
    emptyCart() {
        const store = cartStore()
        store.clearCart()
    },
    validateCartTimestamp() {
        const store = cartStore()
        const timestamp = store.timestamp

        // Caso não exista o timestamp, retorna true para que o redirecionamento possa acontecer
        if (!timestamp) {
            return true
        }

        let now = Date.now()
        return dateService.differenceInMinutes(timestamp, now) > 1500
    },
    deleteCartTimestamp() {
        const store = cartStore()
        store.timestamp = null
    }
}